import { Avatar, AvatarFallback } from "./ui/avatar";

interface MessageAvatarProps {
  isUser: boolean;
  userName: string;
  targetName: string;
}

export const MessageAvatar = ({
  isUser,
  userName,
  targetName,
}: MessageAvatarProps) => {
  return (
    <Avatar className="w-8 h-8 flex-shrink-0 sm:block hidden">
      <AvatarFallback
        className={`${
          isUser
            ? "bg-gradient-to-bl from-gray-300 to-gray-900 text-white"
            : "bg-gradient-to-br from-gray-50 to-gray-400 text-gray-900"
        } font-semibold`}
      >
        {isUser ? userName[0] : targetName[0]}{" "}
      </AvatarFallback>
    </Avatar>
  );
};
